var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { Component } from "react";
import styled from "styled-components";
import Form from "@irati/ui/src/Form";
import { Para } from "@irati/ui/src/Labels";
import { Email } from "@irati-web/fields/user";
import { FormattedMessage } from "@irati/utils/lang";
import ContinueBackButtons from "../ContinueBackButtons";
import { GET_STARTED, SET_PROFILE_INFO } from "../../containers/Home/GetStarted";
var Description = styled(Para)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  text-align: center;\n  margin-bottom: 30px;\n"], ["\n  text-align: center;\n  margin-bottom: 30px;\n"])));
var Content = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  max-width: 360px;\n  margin: 0 auto;\n"], ["\n  max-width: 360px;\n  margin: 0 auto;\n"])));
var EmailStep = /** @class */ (function (_super) {
    __extends(EmailStep, _super);
    function EmailStep() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    EmailStep.prototype.render = function () {
        var _a = this.props, email = _a.email, onUpdateEmail = _a.onUpdateEmail, onUpdateStep = _a.onUpdateStep;
        return (React.createElement(Form, null,
            React.createElement(Description, { large: true },
                React.createElement(FormattedMessage, { id: "medical.landing.steps.email.desc" })),
            React.createElement(Content, null,
                React.createElement(Email, { label: "", value: email, onChange: onUpdateEmail }),
                React.createElement(Para, { light: true, narrow: true },
                    React.createElement(FormattedMessage, { id: "medical.landing.steps.email.para" })),
                React.createElement(ContinueBackButtons, { onBack: function () { return onUpdateStep(GET_STARTED); }, onContinue: function () { return onUpdateStep(SET_PROFILE_INFO); } }))));
    };
    return EmailStep;
}(Component));
export default EmailStep;
var templateObject_1, templateObject_2;
